/* eslint-disable max-len */
import React from 'react';
import PayoutArrowup from '../../../../svgs/PayoutArrowup';
import { formatCash } from '../../../../utils/tableHelpers';
import RewardPieChart from '../RewardPieChart';
import Styles from './RewardCollection.module.scss';

interface IRewardCollection{
  payload:any;
}
const RewardCollection = ({ payload }:IRewardCollection) => {
  const details = [
    {
      id: 1,
      title: 'Total amount paid',
      value: `$${formatCash(payload?.totalAmountPaid || 0)}`,
      color: '#5941A9',
    },
    {
      id: 2,
      title: 'Total amount withdrawn',
      value: `$${formatCash(payload?.totalAmountWithdrawn || 0)}`,
      color: '#170063',
    },
  ];

  const percentageType = (value:number) => {
    if (value < 0) {
      return {
        className: Styles.wrapper__payoutPercentDecrease,
        color: '#F04438',
      };
    }
    return {
      className: Styles.wrapper__payoutPercent,
    };
  };

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__title}>Collections</div>
      <div className={Styles.wrapper__pieChartAndDetails}>
        <div className={Styles.wrapper__pieChart}>
          <RewardPieChart payload={payload} />
        </div>
        <div className={Styles.wrapper__pieDetails}>
          <div className={Styles.wrapper__pieTotalPayoutsAndValues}>
            <div className={Styles.wrapper__payoutTitle}>
              Total payouts:
            </div>
            <div className={Styles.wrapper__payoutValue}>
              $
              {formatCash(payload?.totalAmountWithdrawn || 0)}
              <div className={percentageType(parseInt(payload?.totalAmountWithdrawnPercentageChange))?.className}>
                <span><PayoutArrowup color={percentageType(parseInt(payload?.totalAmountWithdrawnPercentageChange))?.color} /></span>
                {parseInt(payload?.totalAmountWithdrawnPercentageChange)}
                %
              </div>
            </div>
          </div>
          {
            // eslint-disable-next-line max-len
            details?.map((list) => (
              <div className={Styles.wrapper__pieAmountContainer} key={list?.id}>
                <div className={Styles.wrapper__pieAmountCircle} style={{ background: list?.color }} />

                <div className={Styles.wrapper__pieAmountTitle}>{list?.title}</div>
                <div className={Styles.wrapper__pieAmountValue}>{list?.value}</div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
};

export default RewardCollection;
